import { AvatarUser } from "@/components/avatar-user/components/avatar-user";
import { useContextPageRoot } from "../../context/root-context";

export const HeaderNavigateAvatar = () => {
  const { profile } = useContextPageRoot();

  return <AvatarUser login={profile?.Login} />;
};
